<template>
  <v-app>
    <v-app-bar app color="white" height="100">
      <v-avatar class="mr-3" color="grey lighten-5" size="70">
        <v-img contain src="./assets/android.jpg"></v-img>
      </v-avatar>

      <v-toolbar-title class="font-weight-black headline">
        <router-link to="/">BUN ALERT</router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-title class="headline">
        <number class="bold transition" :class="{ scaleBig: scaleClass }" ref="number2" :from="numberFrom"
          :format="theFormat" animationPaused :to="numberTo" :duration="duration" easing="Power4.easeOut"
          @complete="completed" />
        BUNS
      </v-toolbar-title>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer class="justify-center" color="#292929">
      <v-btn color="white" to="privacy-policy" text>Privacy Policy</v-btn>
      <v-btn color="white" to="terms-and-conditions" text>Terms and Conditions</v-btn>
      <v-btn color="white" to="faq" text>FAQ</v-btn>
    </v-footer>
    <v-footer class="justify-center" color="#292929" height="50">
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ new Date().getFullYear() }} — Bun Alert — refect
      </div>
      <br />
    </v-footer>
  </v-app>
</template>

<script>
import { collection, getCountFromServer } from "firebase/firestore";
import { db } from "./firebase";

export default {
  name: "App",

  data () {
    return {
      buns: [],
      numberFrom: 0,
      numberTo: 0,
      duration: 5,
      scaleClass: false,
    };
  },

  async mounted () {

    const bunRef = collection(db, "buns");
    const snapshot = await getCountFromServer(bunRef);
    this.numberTo = snapshot.data().count;

    setTimeout(() => {
      this.playAnimation();
    }, 1000);
  },

  methods: {
    theFormat (number) {
      return number.toFixed(0);
    },
    completed () {
      // console.log('Animation ends!')
      // this.scaleClass = true
    },
    playAnimation () {
      // console.log('Animation starts!')
      this.scaleClass = false;
      this.$refs.number2.play();
    },
  },
};
</script>

<style scoped>
.bold {
  color: #46c3fe;
  font-weight: bold;
  font-size: 25px;
}

.transition {
  transition: all 0.3s ease-in;
}

.scaleBig {
  font-size: 35px;
}

/* unvisited link */
a:link,
a:visited {
  color: black;
  text-decoration: none;
}
</style>
